import { EfipayCurrency } from "app_types/efipay/efipayTypes";
import { IHttpResponse } from "app_types/httpTypes";

export enum ERPNature {
  NATURAL = 'NATURAL',
  JURIDICA = 'JURIDICA'
}

export enum ERPClassification {
  GRAN_CONTRIBUYENTE_AUTORRETENEDOR = '01_GRAN CONTRIBUYENTE AUTORRETENEDOR',
  GRAN_CONTRIBUYENTE_ON_AUTORRETENEDOR = '02_GRAN CONTRIBUYENTE NO AUTORRETENEDOR',
  REGIMEN_COMUN_AUTORRETENEDOR = '03_REGIMEN COMUN AUTORRETENEDOR',
  REGIMEN_COMUN_NO_AUTORRETENEDOR = '04_REGIMEN COMUN NO AUTORRETENEDOR',
  ENTIDADES_DEL_ESTADO = '06_ENTIDADES DEL ESTADO',
  REGIMEN_ESPECIAL = '07_REGIMEN ESPECIAL',
  NO_RESPONSABLE = '10_NO RESPONSABLE',
}

export interface IGetCertificatePriceResponse extends IHttpResponse {
  price: Record<EfipayCurrency, number>
}
